// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"49eb3b44","335":"62aaf414"}[chunkId] + ".chunk.js";
};